export default {
    'key' : 'module B value'
}
